import { RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AddCrowdsaleLayoutComponent } from "./add-crowdsale.layout";
import { AddCrowdsaleComponent } from "./add-crowdsale.component";

export const routes: Routes = [
    {
        path: "",
        component: AddCrowdsaleLayoutComponent,

        children: [
            {
                path: "",
                component: AddCrowdsaleComponent,
            },
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AddCrowdsaleRoutingModule {}
